// Mock data para Ser Tão Doce - Confeitaria

export const brigadeiros = [
  {
    id: 'brig-1',
    name: 'Amêndoas Torradas',
    description: 'Brigadeiro branco saborizado com pasta de amêndoas',
    category: 'brigadeiros',
    image: '/images/amendoastorradas.jpeg'
  },
  {
    id: 'brig-2',
    name: 'Avelã',
    description: 'Brigadeiro cremoso com avelãs selecionadas',
    category: 'brigadeiros',
    image: '/images/avela.jpeg'
  },
  {
    id: 'brig-3',
    name: 'Café',
    description: 'Intenso sabor de café em cada mordida',
    category: 'brigadeiros',
    image: '/images/cafee.jpeg'
  },
  {
    id: 'brig-4',
    name: 'Chocolate Branco',
    description: 'Suave e cremoso chocolate branco',
    category: 'brigadeiros',
    image: '/images/brancoo.jpeg'
  },
  {
    id: 'brig-5',
    name: 'Cajuzinho',
    description: 'Amendoim com chocolate - clássico brasileiro',
    category: 'brigadeiros',
    image: '/images/caj.jpeg'
  },
  {
    id: 'brig-6',
    name: 'Coco',
    description: 'Irresistível combinação de coco e chocolate',
    category: 'brigadeiros',
    image: '/images/coconut.jpeg'
  },
  {
    id: 'brig-7',
    name: 'Churros',
    description: 'Massa branca saborizada com doce de leite e canela',
    category: 'brigadeiros',
    image: '/images/churros.png'
  },
  {
    id: 'brig-8',
    name: 'Creme Brûlée',
    description: 'Sofisticado sabor de creme brûlée',
    category: 'brigadeiros',
    image: '/images/brule.jpeg'
  },
  {
    id: 'brig-9',
    name: 'Caramelo Salgado',
    description: 'Perfeito equilíbrio entre doce e salgado',
    category: 'brigadeiros',
    image: '/images/caramelo.png'
  },
  {
    id: 'brig-10',
    name: 'Casadinho',
    description: 'Massa branca e ao leite - união perfeita',
    category: 'brigadeiros',
    image: '/images/casadinho.jpeg'
  },
  {
    id: 'brig-11',
    name: 'Framboesa',
    description: 'Brigadeiro branco recheado com geleia de framboesa, finalizado com framboesa liofilizada',
    category: 'brigadeiros',
    image: '/images/frambo.jpeg'
  },
  {
    id: 'brig-12',
    name: 'Hortelã',
    description: 'Refrescante sabor de hortelã',
    category: 'brigadeiros',
    image: '/images/hortela.png'
  },
  {
    id: 'brig-13',
    name: 'Limão',
    description: 'Cítrico e refrescante',
    category: 'brigadeiros',
    image: '/images/branco.png'
  },
  {
    id: 'brig-14',
    name: 'Maracujá com Coco',
    description: 'Tropical e exótico',
    category: 'brigadeiros',
    image: '/images/mariu.png'
  },
  {
    id: 'brig-15',
    name: 'Morango',
    description: 'Doce e suculento sabor de morango',
    category: 'brigadeiros',
    image: '/images/morango.jpeg'
  },
  {
    id: 'brig-16',
    name: 'Chocolate Negro',
    description: 'Intenso e sofisticado chocolate negro',
    category: 'brigadeiros',
    image: '/images/negr.jpeg'
  },
  {
    id: 'brig-17',
    name: 'Nido com Nutella',
    description: 'Crocante leite em pó com Nutella cremosa',
    category: 'brigadeiros',
    image: '/images/nutella.jpeg'
  },
  {
    id: 'brig-18',
    name: 'Oreo',
    description: 'Brigadeiro com pedaços crocantes de Oreo',
    category: 'brigadeiros',
    image: '/images/oreo.jpeg'
  },
  {
    id: 'brig-19',
    name: 'Pistache',
    description: 'Sabor marcante e sofisticado de pistache',
    category: 'brigadeiros',
    image: '/images/pistacho.jpeg'
  },
  {
    id: 'brig-20',
    name: 'Queijo com Goiabada',
    description: 'Clássica combinação brasileira de queijo e goiabada',
    category: 'brigadeiros',
    image: '/images/queijo com goaibada.png'
  },
  {
    id: 'brig-21',
    name: 'Tradicional',
    description: 'O clássico brigadeiro ao leite tradicional',
    category: 'brigadeiros',
    image: '/images/tradicional.jpeg'
  }
];

export const bombons = [
  {
    id: 'bomb-1',
    name: 'Ao Leite',
    description: 'Casquinha e ganache de chocolate ao leite',
    category: 'bombons',
    image: '/images/ao leite.png'
  },
  {
    id: 'bomb-2',
    name: 'Café',
    description: 'Casquinha de chocolate ao leite, ganache de café e noz pecan',
    category: 'bombons',
    image: '/images/cafe.png'
  },
  {
    id: 'bomb-3',
    name: 'Caramelo',
    description: 'Casquinha de chocolate ao leite com caramelo salgado',
    category: 'bombons',
    image: '/images/caramelobombom.png'
  },
  {
    id: 'bomb-4',
    name: 'Castanha do Brasil',
    description: 'Chocolate intenso com praliné de castanha',
    category: 'bombons',
    image: '/images/castanha do brasil.png'
  },
  {
    id: 'bomb-5',
    name: 'Chocolate Intenso',
    description: 'Ganache intenso de chocolate negro',
    category: 'bombons',
    image: '/images/chocolate intenso.png'
  },
  {
    id: 'bomb-6',
    name: 'Cupuaçu',
    description: 'Casquinha de chocolate com ganache de cupuaçu',
    category: 'bombons',
    image: '/images/cupuacu.png'
  },
  {
    id: 'bomb-7',
    name: 'Chocolate Branco',
    description: 'Casquinha e ganache de chocolate branco com baunilha',
    category: 'bombons',
    image: '/images/chocolate branco.png'
  },
  {
    id: 'bomb-8',
    name: 'Framboesa com Pistache',
    description: 'Casquinha de chocolate branco com framboesa e pistache',
    category: 'bombons',
    image: '/images/framboesa com pistach.png'
  },
  {
    id: 'bomb-9',
    name: 'Maracujá com Coco',
    description: 'Casquinha de chocolate branco com maracujá e coco',
    category: 'bombons',
    image: '/images/maracuja.png'
  },
  {
    id: 'bomb-10',
    name: 'Red Velvet',
    description: 'Casquinha de chocolate intenso e cream cheese',
    category: 'bombons',
    image: '/images/red velvet.png'
  },
  {
    id: 'bomb-11',
    name: 'Tortinha de Limão',
    description: 'Casquinha de chocolate branco, ganache de limão e suspiro',
    category: 'bombons',
    image: '/images/tortinha d elimao.png'
  }
];

export const pricingBrigadeiros = [
  { units: 6, flavors: 2, price: '€10,50' },
  { units: 9, flavors: 3, price: '€15,75' },
  { units: 12, flavors: 3, price: '€21,00' },
  { units: 20, flavors: 4, price: '€33,00' },
  { units: 25, flavors: 5, price: '€40,00' },
  { units: 50, flavors: 5, price: '€78,00' },
  { units: 100, flavors: 10, price: '€150,00' }
];

export const pricingBrigadeirosFesta = [
  { units: 50, flavors: 5, price: '€50,00', weight: '15g' },
  { units: 100, flavors: 10, price: '€90,00', weight: '15g' }
];

export const pricingBombons = [
  { units: 6, flavors: 2, price: '€9,00' },
  { units: 9, flavors: 3, price: '€13,50' },
  { units: 12, flavors: 3, price: '€17,40' },
  { units: 20, flavors: 4, price: '€28,00' },
  { units: 25, flavors: 5, price: '€33,75' },
  { units: 50, flavors: 5, price: '€62,50' },
  { units: 100, flavors: 10, price: '€120,00' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Maria Silva',
    text: 'Os melhores brigadeiros que já provei! A qualidade é incomparável e o sabor é divinal.',
    rating: 5
  },
  {
    id: 2,
    name: 'João Costa',
    text: 'Encomendar foi super fácil e a entrega pontual. Os bombons são perfeitos para presente!',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana Rodrigues',
    text: 'Produto artesanal de excelência! Cada doce é uma obra de arte. Recomendo!',
    rating: 5
  }
];

export const whatsappOrderNumber = '351913856811';

export const socialLinks = {
  instagram: 'https://www.instagram.com/sertaodoce.pt',
  whatsapp: `https://api.whatsapp.com/send/?phone=${whatsappOrderNumber}&text&type=phone_number&app_absent=0`,
  tiktok: 'https://www.tiktok.com/@sertaodoce.pt',
  facebook: 'https://www.facebook.com/profile.php?id=100088114044853',
  threads: 'https://www.threads.com/@sertaodoce.pt'
};

export const contactInfo = {
  phone: '+351 913 856 811',
  email: 'contato@sertaodoce.pt',
  address: 'Waleria Mapeli - Portugal'
};
